import React, { useEffect, useState } from "react";
import Navbar from "../../components/common/Navbar";
import BannerSection from "../../components/common/BannerSection";
import ContactBanner from "../../assets/images/banner-bg1.jpg";
import { Link } from "react-router-dom";
import { config } from "../config";
import { useInView } from 'react-intersection-observer';
import { Helmet } from "react-helmet";
import axios from "axios";
import moment from "moment";
import Loader from "../../components/common/Loader";
const Blogs = () => {
  useEffect(() => window.scrollTo(0, 0), [])
  const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 10;


  useEffect(() => {
    // Fetch blogs from Laravel API
    const fetchBlogs = async () => {
      try {
        const response = await axios.get("https://earth.cubextechnology.com/api/blogs");
        setBlogs(response.data.blogs);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  const totalPages = Math.ceil(blogs.length / blogsPerPage);

  // Get blogs for the current page
  const currentBlogs = blogs.slice(
    (currentPage - 1) * blogsPerPage,
    currentPage * blogsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  return (
    <div>
      {loading && <Loader />}
      <Helmet><title>Empowering Your Digital Journey with Insightful Web Development Stories.</title></Helmet>
      <Navbar inner={true} />
      <BannerSection
        Banner={ContactBanner}
        title={"Blog"}
        subtitle={"When asked the question"}
      />
      <div className="blog-area pt-80 pb-50">
        <div className="container">
          <div className="row justify-content-center">
            {currentBlogs?.slice(0, 10).map((obj, i) => (
              <div key={i} className="col-lg-4 col-md-6 aos-init aos-animate">
                <div className="single-blog-post">
                  <div className="blog-image">
                    <Link
                      to={`${config.appUrl}blog-detail/${obj.slug}`}
                    >
                      <img className="img-fluid" src={`${config.imageUrl}/blogs/${obj.main_image}`} alt={obj.title} />
                    </Link>
                    <div className="date">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="16" y1="2" x2="16" y2="6"></line>
                        <line x1="8" y1="2" x2="8" y2="6"></line>
                        <line x1="3" y1="10" x2="21" y2="10"></line>
                      </svg>
                      {moment(obj.created_at).format("MMMM D, YYYY")}
                    </div>
                  </div>
                  <div className="blog-post-content">
                    <h3>
                      <Link
                        to={`${config.appUrl}blog-detail/${obj.slug}`}
                        className="blog-id"
                      >
                        {obj.title}
                      </Link>
                    </h3>
                    <span>
                      By <a href="/#">{obj.admin_name}</a>
                    </span>
                    <p>
                      <p dangerouslySetInnerHTML={{ __html: obj.content.slice(0, 140) + "...." }}></p>
                    </p>
                    <Link
                      to={`${config.appUrl}blog-detail/${obj.slug}`}
                      className="read-more-btn"
                    >
                      Read More{" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
            ))
            }
            {totalPages > 1 && (
              <div className="pagination justify-content-center">
                {Array.from({ length: totalPages }, (_, index) => (
                  <button
                    key={index + 1}
                    onClick={() => handlePageChange(index + 1)}
                    disabled={currentPage === index + 1}
                  >
                    {index + 1}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div >
    </div >
  );
};

export default Blogs;
